import { head, last, merge } from 'lodash';
import moment from 'moment';

class AvailabilitySliderController {

  constructor($scope, $timeout, availabilityService, availabilityApiService, dateService, itemService, storeService, loginoutService, configService, loadingService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.availabilityService = availabilityService;
    this.availabilityApiService = availabilityApiService;
    this.dateService = dateService;
    this.itemService = itemService;
    this.storeService = storeService;
    this.loginoutService = loginoutService;
    this.configService = configService;
    this.loadingService = loadingService;
  }

  $onInit () {
    this.travelNext = null;
    this.travelPrevious = null;
    this.today = moment();
    this.startDate = null;
    this.endDate = null;
    this.error = false;
    this.isSearching = false;

    this.availabilityService.resetSingleDays();
  }

  setupDays () {
    if (!this.loadingService.isLoading('availability') && this.availability) {
      if (!this.availabilityService.hasSingleDays()) {
        this.setDays();
      }

      return this.availabilityService.getSingleDays();
    }
  }

  setDays () {
    this.availabilityService.resetSingleDays();
    let days = [];

    this.filterAvailability();

    this.availability.forEach((availability) => {
      let day = moment(availability.date);

      days.push(merge({
        name: day.format('ddd'),
        number: day.format('DD')
      }, availability));

      this.availabilityService.setSingleDays(days);
    });

    this.itemService.setItem(this.item);

    if (this.item.phone_only) {
      this.item.date = head(this.availability).date || null;
      return Promise.resolve();
    }

    return this.itemService.setupItemAvailability(this.availability, this.startDate)
      .then(() => {
        return this.getQuantity();
      });
  }

  monthYear () {
    if (this.availability) {
      this.startDate = moment(head(this.availability).date, 'YYYY-MM-DD');
      this.endDate = moment(last(this.availability).date, 'YYYY-MM-DD');

      if (this.startDate.isSame(this.endDate, 'month')) {
        return this.startDate.format('MMMM YYYY');
      }

      if (this.startDate.isSame(this.endDate, 'year')) {
        return `${this.startDate.format('MMM')}–${this.endDate.format('MMM YYYY')}`;
      }

      return `${this.startDate.format('MMM YYYY')}–${this.endDate.format('MMM YYYY')}`;
    }

    let searchDate = this.storeService.get('searchDate');
    if (searchDate) {
      return moment(searchDate)
        .format('MMMM YYYY');
    }

    return this.today.format('MMMM YYYY');
  }

  selectDay (availableDay) {
    if (!this.isDateSelected(availableDay)) {
      this.staff = undefined;

      this.itemService.setItem(this.item);

      if (this.item.phone_only) {
        this.item.date = availableDay.date;
        return Promise.resolve();
      }

      this.loadingService.startLoading('times');

      return this.itemService.updateAvailability(availableDay)
        .then(() => {
          this.item = this.itemService.getItem();
          this.item.interacted = true;
          this.loadingService.stopLoading('times');

          this.getQuantity();
        });
    }
  }

  isDateSelected (day) {
    return this.item.date === day.date;
  }

  isNextDateValid (direction = null) {
    if (!this.loadingService.isLoading('availability') && !this.error) {
      if (this.availability) {
        if (direction === 'previous') {
          return !this.startDate.isSame(this.today, 'day');
        }

        return !moment(this.endDate)
          .add(1, 'days')
          .diff(this.today, 'years') > 0;
      }
    }

    return false;
  }

  nextAvailability () {
    this.travelNext = true;
    this.isSearching = true;

    return this.updateAvailability('next')
      .then(() => {
        this.travelNext = null;
      });
  }

  previousAvailability () {
    this.travelPrevious = true;
    this.isSearching = true;

    return this.updateAvailability('previous')
      .then(() => {
        this.travelPrevious = null;
      });
  }

  updateAvailability (direction = undefined) {
    this.loadingService.startLoading([ 'availability', 'times' ]);
    this.error = false;
    this.noEditAvailability = false;
    this.availabilityService.resetSingleDays();

    this.setStartEndDates(direction);

    if (this.basket && this.basket.store_offer) {
      this.item.offer = {
        id: this.basket.store_offer
      };
    }

    return this.availabilityApiService.requestAvailability(this.startDate.format('YYYY-MM-DD'), this.endDate.format('YYYY-MM-DD'), this.eventType, this.item.id, this.item.offer ? this.item.offer.id : 'storefront')
      .then(response => {
        this.availability = response;

        this.availabilityService.resetSingleDays();
        return this.setupDays();
      })
      .catch(() => {
        this.availabilityService.resetSingleDays();
        this.error = true;
      })
      .then(response => {
        this.loadingService.stopLoading('availability');
        this.$timeout(() => {
          this.$scope.$digest();
        });
        return response;
      });
  }

  setStartEndDates (direction) {
    let start = null;
    let end = null;

    switch (direction) {
    case 'next':
      start = moment(this.endDate.add(1, 'days'));
      end = this.endDate.add(6, 'days');
      break;
    case 'previous':
      end = moment(this.startDate.subtract(1, 'days'));
      start = this.startDate.subtract(6, 'days');
      break;
    default:
      start = moment(this.startDate);
      end = this.startDate.add(6, 'days');
      this.isSearching = false;
    }

    this.startDate = this.dateService.checkMaxDate(start, true);
    this.endDate = this.dateService.checkMaxDate(end);

    this.startDateNotBeforeToday();
  }

  startDateNotBeforeToday () {
    if (this.startDate.isBefore(this.today, 'day')) {
      this.startDate = moment();
      this.endDate = moment()
        .add(6, 'days');
    }

    this.storeService.set('searchDate', this.startDate.format('YYYY-MM-DD'));
  }

  goToToday () {
    this.startDate = moment();
    return this.updateAvailability();
  }

  updateDate (update = false) {
    if (this.item.date) {
      if (update) {
        this.storeService.set('searchDate', this.item.date);
      }
      this.startDate = moment(this.item.date);
      this.updateAvailability();
    }
  }

  displayOriginalPrice (day) {
    return day.available && day.original_price !== day.price;
  }

  hasLoaded () {
    return !!(!this.loadingService.isLoading('availability') && this.availability);
  }

  filterAvailability () {
    if (this.isNotEditing()) {
      return false;
    }

    let start = moment(this.storeService.get('start_date'), 'YYYY-MM-DD');
    let end = moment(this.storeService.get('end_date'), 'YYYY-MM-DD');

    this.availability = this.availability.map(day => {
      let date = moment(day.date, 'YYYY-MM-DD');
      if (date.isBefore(start)
        || date.isAfter(end)) {
        day.available = false;
      }

      return day;
    });

    if(this.availability.findIndex(day => {
      return day.available;
    }) === -1) {
      this.loadingService.stopLoading([ 'availability', 'times' ]);
      this.noEditAvailability = true;
    }
  }

  isNotEditing () {
    return !this.loginoutService.isEditing();
  }

  availableContactMethods () {
    let contactMethods = this.configService.get('property').contactMethods;

    if (!contactMethods.email && !contactMethods.phone) {
      return false;
    }

    return '<strong>' + Object.values(contactMethods)
      .filter(Boolean)
      .join('</strong> or <strong>') + '</strong>';
  }
}

AvailabilitySliderController.$inject = [ '$scope', '$timeout', 'availabilityService', 'availabilityApiService', 'dateService', 'itemService', 'storeService', 'loginoutService', 'configService', 'loadingService' ];

export default AvailabilitySliderController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/controllers/availabilitySlider.controller.js